<template lang="pug">
include ../pug/svg
div#activitylist(if="course")
	div#ctrl
		div
			Search(v-model:search="search")
			Filter(id="attemptFilter" label="Attempt" title="Attempts" :options="attemptFilters" v-model:selected="attemptFilter")
	div.wrapper(v-if="refreshed")
		//-img(:src="certificationBase64" width="420" height="594")
		div.c1.listbg
			ul.list
				li.person(v-for="(attempt, index) in filteredAttempts" :attempt="attempt" :index="index" @mouseenter="previewIndex=index" :class="{active:previewIndex===index}")
					picture.user(v-if="attempt.user.profileUrl" :class="{online:attempt.user.online}")
						img(:src="attempt.user.profileUrl" width="40" height="40" :alt="attempt.user.fullName")
					span.user(v-else :class="{online:attempt.user.online}") {{attempt.user.initials}}
					
					div.hgroup
						h2 {{attempt.user.fullName}}
						//-h3 {{terminology('user', attempt.courseRole.slug,'singular')}}
						h3 {{assignedRoleStr(attempt)}}
					template(v-if="attemptAccess(attempt)")
						div.butmore(v-if="attempt.tasks.examMode && attempt.tasks.total")
							a(v-if="attempt.completed && attempt.tasks.pending" role="button" @click="toggleModal('pending')") Mark Tasks
							a(v-else role="button" @click="toggleModal(true)") All Activity
							button.but(type="button" aria-haspopup="true" aria-controls="" @mouseenter="toggleTint(true),setMenu($event)" @mouseleave="toggleTint(false)") More
								+svg(svg-filename="iconMore" aria-hidden="true" alt="More icon")
							nav.menu(@mouseenter="toggleTint(true)" @mouseleave="toggleTint(false)")
								div.bar
									+svg(svg-filename="iconMore" aria-hidden="true")
									a.but(role="button") Close
										+svg(svg-filename="iconClose")
								ul
									li
										a(role="button" @click="toggleModal('all')") View tasks
									li(v-if="attempt.tasks.correct")
										a(role="button" @click="toggleModal('correct')") View correct tasks
									li(v-if="attempt.tasks.incorrect")
										a(role="button" @click="toggleModal('incorrect')") View incorrect tasks
									li(v-if="attempt.tasks.pending")
										a(role="button" @click="toggleModal('pending')") View unmarked tasks
									template(v-if="hasCertificate(attempt)")
										li
											a(role="button" @click="generateCertificate(attempt, true)") Download certificate
										li
											a(role="button" @click="generateCertificate(attempt, false)") Print certificate

						button.but.sec(v-else type="button" @click="toggleModal(true)") All Activity
					table.summary
						//-tr(v-if="attempt.attempt>1")
							th Retake
							td(v-if="!attempt.started") Unattempted
							td(v-else) {{number2words(attempt.attempt-2)}} retake
						tr
							th {{terminology('course', 'lesson', 'singular')}} Progress
							td(v-if="!attempt.started") Unattempted
							td(v-else-if="attempt.completed") Completed
							td(v-else) {{completedLessons(attempt)}} of {{totalLessons(attempt)}}
						tr(v-if="attempt.tasks.examMode")
							th {{terminology('course','point','plural')}}
							td(v-if="attempt.completed") {{attempt.tasks.examUserScore}}/{{attempt.tasks.examMaxScore}}
							td(v-else)
								+svg(svg-filename='iconMore')
						tr(v-else-if="attempt.tasks.total")
							th Task Progress
							td {{completedTasks(attempt)}} of {{attempt.tasks.total}}
							//-td(v-if="attempt.completed") {{attempt.tasks.correct}}/{{attempt.tasks.total}} Correct
							//-td(v-else)
								+svg(svg-filename='iconMore')
								
						tr(v-if="attempt.tasks.examMode")
							th Result
							td(v-if="attempt.tasks.result===true")
								+svg(svg-filename='iconHappy') 
								span(v-if="attempt.tasks.examMode") Passed
							td(v-else-if="attempt.tasks.result===false") 
								+svg(svg-filename='iconSad')
								span(v-if="attempt.tasks.examMode") Failed
							td(v-else)
								+svg(svg-filename='iconMore')
					a.arrow View Attempt
						+svg(svg-filename='iconArrow')
		div.c2.sticky(v-if="previewAttempt")
			div.preview
				div.head
					h4 {{previewAttempt.user.fullName}}
					h6(v-if="previewAttempt.user.online") Online
					h6(v-else) Offline
				div.body
					picture.user(v-if="previewAttempt.user.profileUrl" :class="{online:previewAttempt.user.online}")
						img(:src="previewAttempt.user.profileUrl" width="40" height="40" :alt="previewAttempt.user.fullName")
					span.user(v-else :class="{online:previewAttempt.user.online}") {{previewAttempt.user.initials}}
					table.column
						tr
							th Attempt
							td(v-if="!previewAttempt.started") Unattempted
							td(v-else) {{number2words(previewAttempt.attempt-1)}} attempt
							
						template(v-if="!previewAttempt.completed")
							tr
								th {{terminology('course','lesson','singular')}} Progress
								td {{completedLessons(previewAttempt)}} of {{totalLessons(previewAttempt)}} Completed
							tr(v-if="previewAttempt.tasks.total")
								th Task Progress
								td {{completedTasks(previewAttempt)}} of {{previewAttempt.tasks.total}} Completed
								
						template(v-else)
							tr
								th Completion Date/Time
								td {{formatDate(previewAttempt.completed)}}
							tr
								th Completion Duration
								td {{courseCompletionTime(previewAttempt)}}
								
						tr.pic(v-if="previewAttempt.user.userOrganisations[0].role.slug === 'learner' && assignedMentor(previewAttempt)")
							th Assigned {{terminology('user','mentor','singular',true)}}
							td
								picture.user(v-if="assignedMentor(previewAttempt).profileUrl" :class="{online:assignedMentor(previewAttempt).online}")
									img(:src="assignedMentor(previewAttempt).profileUrl" width="40" height="40" :alt="assignedMentor(previewAttempt).fullName")
								a(v-if="false") {{assignedMentor(previewAttempt).fullName}}
								span(v-else) {{assignedMentor(previewAttempt).fullName}}
							
					table.numeric(v-if="previewAttempt.tasks.total")
						tr
							th Tasks
							th Correct
							th(v-if="previewAttempt.tasks.examMode && previewAttempt.completed") {{terminology('course','point','plural')}}
							th(v-else) Incorrect
							th(v-if="previewAttempt.tasks.examMode && previewAttempt.tasks.pending") Unmarked
							th(v-else-if="previewAttempt.tasks.pending") Freeform
							th(v-if="previewAttempt.tasks.examMode") Result
						tr
							td {{previewAttempt.tasks.total}}
							td {{previewAttempt.tasks.correct}}
							td(v-if="previewAttempt.tasks.examMode && previewAttempt.completed")
								span {{previewAttempt.tasks.examUserScore}}
							td(v-else) {{previewAttempt.tasks.incorrect}}
							td(v-if="previewAttempt.tasks.pending") {{previewAttempt.tasks.pending}}
							template(v-if="previewAttempt.tasks.examMode")
								td(v-if="previewAttempt.tasks.result===true || (previewAttempt.tasks.examMode && previewAttempt.tasks.examUserScore >= previewAttempt.tasks.examPassScore)")
									+svg(svg-filename='iconHappy')
								td(v-else-if="previewAttempt.tasks.result===false")
									+svg(svg-filename='iconSad')
								td(v-else)
									+svg(svg-filename='iconMore')
					template(v-if="previewAttempt.tasks.examMode")
						table.column
							tr 
								th Exam Pass Threshold
								td
									span(v-if="previewAttempt.tasks.examPassScore==1") {{previewAttempt.tasks.examPassScore}} out of {{previewAttempt.tasks.examMaxScore}} {{terminology('course','point','singular',true)}}
									span(v-else) {{previewAttempt.tasks.examPassScore}} out of {{previewAttempt.tasks.examMaxScore}} {{terminology('course','point','plural',true)}} are required to pass
							tr(v-if="hasCertificate(previewAttempt)")
								th Certificate ID
								td {{certificateId(previewAttempt)}}
								
	div.modal.center(v-if="refreshed" :class="{active:showModal}")
		template(v-if="previewAttempt")
			div.bar
				+svg(svg-filename="iconMore" aria-hidden="true")
				span Activity / {{previewAttempt.user.fullName}}
				button.but(type="button" @click="toggleModal(false)") Close
					+svg(svg-filename="iconClose")
			div.body
				p
					Filter(id="activityFilter" label="Task Filter" title="Attempts" :options="activityFilters" v-model:selected="activityFilter" :setTint="false")
				dl.activity
					template(v-for="activity in filteredActivities")
						dt(:class="activity.activityType")
							template(v-if="activity.activityType==='task'")
								em(v-if="activity.activityData.taskResult===true")
									+svg(svg-filename='iconTick')
								em(v-else-if="activity.activityData.taskResult===false")
									+svg(svg-filename='iconClose')
								em(v-else)
									+svg(svg-filename="iconMore" aria-hidden="true")
							em(v-else)
								+svg(svg-filename='iconMortarboard')
							span {{formatDate(activity.activityDatetime)}} - {{translateLogTitle(activity.activityData.logTitle)}}
						dd(v-if="activity.activityType === 'course'")
							div {{activity.activityData.courseName}}
						dd(v-if="activity.activityType === 'lesson'")
							div {{activity.activityData.lessonName}}
						dd(v-if="activity.activityType === 'task'")
							div.question {{activity.activityData.taskQuestion}}
							
							template(v-if="activity.activityData.taskResult===true")
								
								template(v-if="activity.activitySubtype === 'freeform'")
									span() User Answer - Awarded ({{activity.activityData.userPoints}}/{{activity.activityData.examPoints}} {{terminologyNumeric(activity.activityData.examPoints,'course','point','plural',true)}})
								
								template(v-else)
									span(v-if="previewAttempt.tasks.examMode") User Answer - Correct ({{activity.activityData.examPoints}} {{terminologyNumeric(activity.activityData.examPoints,'course','point','plural',true)}})
									span(v-else) User Answer - Correct
							
							template(v-else-if="activity.activityData.taskResult===false")
								span(v-if="previewAttempt.tasks.examMode") User Answer - Incorrect (0 {{terminology('course','point','plural',true)}})
								span(v-else) User Answer - Incorrect
							
							template(v-else)
								span(v-if="previewAttempt.tasks.examMode") User Answer - Pending Marking (Award up to {{activity.activityData.examPoints}} {{terminologyNumeric(activity.activityData.examPoints, 'course','point','plural',true)}})
								span(v-else) User Answer
								
							ul.answers(v-if="activity.activitySubtype==='radio' || activity.activitySubtype==='checkbox'")
								li(v-for="(answer, i) in activity.activityData.taskAnswers" :class="{correct:answer.correct,selected:activity.activityData.userAnswers.includes(i)}") {{answer.option}}
									em(v-if="answer.correct")
										+svg(svg-filename='iconHappy')
									em(v-else)
										+svg(svg-filename='iconSad')

							template(v-else-if="activity.activitySubtype==='freeform' && activity.activityData.taskResult===null")
								div.answer(v-html="activity.activityData.userAnswer")
								
								Form.mark(v-if="previewAttempt.tasks.examMode" :validation-schema="markSchema" @submit="markTask")
									Field(name="activityId" type="hidden" :value="activity.id")
									button.but.pri(type="submit") Award Points
									Field(name="userPoints" type="text" maxlength="4" :value="activity.activityData.examPoints" @keydown="keydown")
									ErrorMessage(name="userPoints")
				div.foot
					button.but.sec(type="button" @click="toggleModal(false)") Close
</template>

<script>
import CourseService from '../services/CourseService';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import Search from '../components/Search';
import Filter from '../components/Filter';

import { jsPDF } from 'jspdf';
import { RobotoRegular } from '../../public/font/RobotoRegular.js'
import { RobotoBold } from '../../public/font/RobotoBold.js'

export default {
	name: 'ManageLearningCourseActivity',
	props: ['course'],
	emits: ['storeUpdated'],
	components: {
		Search,
		Filter,
		Form,
		Field,
		ErrorMessage,
	},
	data() {
//		const req = 'Required';
//		const inv = 'Invalid';
		const markSchema = Yup.object().shape({
			userPoints: Yup.string().nullable(),
		});
		return {
			markSchema,			
			search: null,
			previewIndex: 0,
			showModal: false,
			attemptFilter: null,
			attemptFilters: [
				{
					value: 'unattempted',
					option: 'Unattempted',
				},
				{
					value: 'finished',
					option: 'Finished',
				},
				{
					value: 'unfinished',
					option: 'Unfinished',
				},
				{
					value: 'passed',
					option: 'Passed',
				},
				{
					value: 'failed',
					option: 'Failed',
				},
			],
			activityFilter: null,
			activityFilters: [
				{
					value: 'all',
					option: 'All tasks',
				},
				{
					value: 'correct',
					option: 'Correct tasks',
				},
				{
					value: 'incorrect',
					option: 'Incorrect tasks',
				},
				{
					value: 'pending',
					option: 'Unmarked tasks',
				},
			],
			ordinals : 'First Second Third Fourth Fith Sixth Seventh Eight Ninth Tenth Eleventh Twelfth Thirteenth Fourteenth Fifteenth Sixteenth Seventeenth Eighteenth Nineteenth'.split(' '),
			nums : 'zero one two three four five six seven eight nine ten eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen'.split(' '),
			tens : 'twenty thirty forty fifty sixty seventy eighty ninety'.split(' '),
			certificationDefault: '/img/pdf-certificate-thinkhub.jpg',
			certificationBase64: null,
			idRegex: /^[0-9]+(,[0-9]+)*$/,
			refreshed: false,

		};
	},
	async mounted() {
		this.refreshUsers();
		// get certificate image as base64
		const {data} = await CourseService.getCertificate(this.course.id);
		
		if (this.$route.query.ids) {
			// validate passed ids
			if (this.$route.query.ids.match(this.idRegex)) {
				this.search = this.$route.query.ids;
			}
		}
		
		this.certificationBase64 = data.certificationBase64;
	},
	watch: {
		course: {
			handler(course) {
				this.$store.dispatch('gui/setHeader', {
					title: course.name,
					backRoute: {
						text: this.terminology('course','course','plural'),
						name: 'ManageLearning',
					},			
				});		
			},
			deep: false,
		},
	},
	methods: {
		hasCertificate(attempt) {
			if (!this.course.certification || !attempt.completed || (attempt.tasks.examMode && !attempt.tasks.result)) {
				// in progress or failed
				return true;
			}
			
			return true;
		},
		certificateId(attempt) {
			return [this.course.organisationId, this.course.id, attempt.user.id, attempt.attempt].join('_');
		},
		generateCertificate(attempt, download) {
			// pdf generation
			const certData = this.course.certificationData;
			
			const certImg = this.certificationBase64 ? this.certificationBase64 : this.certificationDefault;
			
			const orientations = {
				p: { // portrait
					left: 10,
					center: 105,
					right: 200,
					maxWidth: 190,
				},
				l: { // landscape
					left: 10,
					center: 148.5,
					right: 287,
					maxWidth: 277,
				}
			};
			
			const leftX = orientations[certData.orientation].left;
			const centerX = orientations[certData.orientation].center;
			const rightX = orientations[certData.orientation].right;
			const maxWidth = orientations[certData.orientation].maxWidth;
			
			const pdfOptions = {
				format: 'a4',
				unit: 'mm',
				putOnlyUsedFonts: true,
				orientation: certData.orientation,
			};
			
			const doc = new jsPDF(pdfOptions);
			const tempDoc = new jsPDF(pdfOptions);
			
			// custom font (Roboto) see: https://peckconsulting.s3.amazonaws.com/fontconverter/fontconverter.html
			doc.addFileToVFS('Roboto-Regular.ttf', RobotoRegular);
			doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
			doc.addFileToVFS('Roboto-Bold.ttf', RobotoBold);
			doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold');
			tempDoc.addFileToVFS('Roboto-Regular.ttf', RobotoRegular);
			tempDoc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
			tempDoc.addFileToVFS('Roboto-Bold.ttf', RobotoBold);
			tempDoc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold');
			
			// check requested font is exists (fallback to roboto)
			const fontFamily = (!Object.keys(doc.getFontList()).includes(certData.fontFamily)) ? 'Roboto' : certData.fontFamily;
			const fontNormal = 'normal';
			const fontBold = 'bold';
			
			doc.addImage(certImg, 'JPEG', 0, 0, 210, 297);
			
			doc.setFont(fontFamily, fontNormal);
			
			doc.setFontSize(certData.recipientFontSize).setTextColor(certData.recipientHex);			
			doc.text(attempt.user.fullName, centerX, certData.recipientY, { // note: x val needs to be center of box
				baseline: 'top',
				align: 'center',
				maxWidth: maxWidth,
			});
			
			doc.setFontSize(certData.courseFontSize).setTextColor(certData.courseHex);
			doc.text(this.course.name, centerX, certData.courseY, {
				baseline: 'top',
				align: 'center',
				maxWidth: maxWidth,
			});
			
			doc.setFontSize(certData.footerFontSize);
			doc.text('Certificate ID: '+this.certificateId(attempt), leftX, certData.footerY, { // note: x val needs to be left edge of box
				baseline: 'top',
				align: 'left',
				maxWidth: 90,
			});
			
			const date = new Date(attempt.started);
			const awarded = date.toLocaleString('en-GB', {
				timeZone:'UTC',
				month:'long',
				year: 'numeric',
				day: 'numeric',
			});
			
			doc.text('Awarded: '+awarded, rightX, certData.footerY, { // note: x val needs to be right edge of box
				baseline: 'top',
				align: 'right',
				maxWidth: 90,
			});
			
			doc.setFontSize(certData.signatoryFontSize);
			tempDoc.setFontSize(certData.signatoryFontSize);
			
			const signatory = '**'+certData.signatoryName+'**, '+certData.signatoryPosition;
			const signatoryOpts = {
				baseline: 'top',
				align: 'left',
			};
			
			let signatoryX = centerX;
			let lineWidth = 0;
			
			// calculate signatory width in temp doc (for inline bold text)
			signatory.split('**').map((text, i) => {
				if (i % 2 === 0) {
					tempDoc.setFont(fontFamily, fontNormal);
				} else {
					tempDoc.setFont(fontFamily, fontBold);
				}
				
				tempDoc.text(text, signatoryX, certData.signatoryY, signatoryOpts);
				
				const textWidth = tempDoc.getTextWidth(text);
				signatoryX += textWidth;
				lineWidth += textWidth;
			});
			
			// set start point based on final signatory width (so it can be centered)
			signatoryX = centerX - (lineWidth / 2);
			
			// generate signatory in doc
			signatory.split('**').map((text, i) => {
				if (i % 2 === 0) {
					doc.setFont(fontFamily, fontNormal);
				} else {
					doc.setFont(fontFamily, fontBold);
				}
				
				doc.text(text, signatoryX, certData.signatoryY, signatoryOpts);
				
				signatoryX += doc.getTextWidth(text);
			});
			
			if (download) {
				// download
				doc.save('certificate_' + this.certificateId(attempt) + '.pdf');				
			} else {
				// output in new window
				doc.autoPrint({variant: 'non-conform'});
				doc.output('dataurlnewwindow');
			}
		},
		assignedMentor(previewAttempt) {
			const userOrganisationId = previewAttempt.user.userOrganisations[0].userOrganisationId;
			return (userOrganisationId) ? this.$store.getters['users/getUserByUserOrganisationId'](userOrganisationId) : null;
		},
		assignedRoleStr(attempt) {
			var courseRole = this.terminology('user', attempt.courseRole.slug, 'singular');
			var orgRole = this.terminology('user', attempt.user.userOrganisations[0].role.slug, 'singular');
			
			return (courseRole === orgRole) ? orgRole : orgRole + ' > ' + courseRole;
		},
		keydown(event) {
			const allowedKeys = ['Backspace','Shift','Tab','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','0','1','2','3','4','5','6','7','8','9'];
			
			if (allowedKeys.indexOf(event.key) < 0) {
				// restricted key
				event.preventDefault();
			}
		},
		attemptAccess(attempt) {
			// restrict granular access/manual marking to roles
			const authUserOrg = this.$store.getters['auth/getUserOrg'];
			const validRole = this.$store.getters['gui/hasFeature']('course','activity');
			
			if (!validRole) {
				return false;
				
			} else if (authUserOrg.role.slug === 'mentor') {
				const mentorId = authUserOrg.id;
				const assignedMentorId = attempt.user.userOrganisations[0].userOrganisationId;
				
				if (this.org.assignmentIndividual && mentorId !== assignedMentorId) {
					return false;
				}
			}
			
			return true;
		},
		markTask(values, actions) {
			const activity = this.filteredActivities.find(a => a.id == values.activityId);
			const maxPoints = activity.activityData.examPoints;
			let userPoints = values.userPoints;
			
			if (userPoints > maxPoints) {
				actions.setFieldError('userPoints', 'Maximum award is '+maxPoints+' points');
				return;
				
			} else if (userPoints < 0) {
				actions.setFieldError('userPoints', 'Minimum award is 0 points');
				return;
			}
			
			// update activity data
			this.$store.dispatch('courses/setUserTaskPoints', {
				activity: activity,
				taskResult: (userPoints > 0),
				userPoints,
			});
		},
		setMenu(event) {
			if (event.target.nodeName === 'BUTTON' && event.relatedTarget.nodeName !== 'NAV') {
				const menu = event.target.nextSibling;
				menu.classList.remove('reverse');				
				const rect = menu.getBoundingClientRect();
				
				if (rect.bottom > window.innerHeight) {
					menu.classList.add('reverse');
				}
			}
		},
		toggleTint(bool) {
			this.$store.dispatch('gui/setTintState', bool);
		},
		toggleModal(bool) {
			if (bool !== true && bool !== false) {
				this.activityFilter = this.activityFilters.find(f => f.value === bool);
				bool = true;
			}
			
			this.showModal = bool;
			this.$store.dispatch('gui/setTintState', bool);
		},
		terminologyNumeric(number, groupKey, termKey, lowercase) {
			const varKey = (number == 1) ? 'singular' : 'plural';
			return this.terminology(groupKey, termKey, varKey, lowercase);
			
		},
		terminology(groupKey, termKey, varKey, lowercase) {
			const translation = this.$store.getters['gui/customTerm'](groupKey, termKey, varKey);
			return (lowercase) ? translation.toLowerCase() : translation;
		},
		translateLogTitle(logTitle) {
			for (let key in this.$store.state.gui.termMap.course.vars) {
				const singular = this.terminology('course', key, 'singular');
				const re = new RegExp(key, 'gi');
				
				logTitle = logTitle.replace(re, singular); 
			}
			
			return logTitle;
		},
		async refreshUsers() {
			// ensure data has loaded before render
			this.refreshed = false;
			
			// load users from db
			await this.$store.dispatch('users/dbUsers');
			
			this.refreshed = true;
		},
		formatDate(isoDate) {
			const date = new Date(isoDate);
			return date.toLocaleString('en-GB', {
				timeZone:'UTC',
				month:'short',
				year: 'numeric',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true,
			});
		},
		number2words(n) {
			if (n < 20) return this.ordinals[n];
			
			var digit = n%10;
			if (n < 100) return this.tens[~~(n/10)-2] + (digit? '-' + this.nums[digit]: '');
			if (n < 1000) return this.nums[~~(n/100)] +' hundred' + (n%100 == 0? '': ' and ' + this.number2words(n%100));
			return this.number2words(~~(n/1000)) + ' thousand' + (n%1000 != 0? ' ' + this.number2words(n%1000): '');
		},
		totalLessons() {
			return this.course.courseLessons.length;
		},
		completedLessons(attempt) {
			const completedLessons = attempt.activities.filter(a => a.activityType === 'lesson' && a.activitySubtype === 'completed');
			return completedLessons.length;
		},
		completedTasks(attempt) {
			return (attempt.tasks.total) ? (attempt.tasks.pending + attempt.tasks.correct + attempt.tasks.incorrect) : 0;
		},
		courseCompletionTime(attempt) {
			if (attempt.completed === false) {
				return 'In progress';
				
			} else {
				const courseCompletion = attempt.activities.find(a => a.activityType === 'course' && a.activitySubtype === 'completed');
				const totalSeconds = courseCompletion.activityData.completionTime;
				
				const days = Math.floor(totalSeconds / (3600 * 24));
				const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
				const minutes = Math.floor((totalSeconds % 3600) / 60);
				const seconds = Math.floor(totalSeconds % 60);
				
				const daysStr = this.pluraliseTime(days, 'day');
				const hoursStr = this.pluraliseTime(hours, 'hour');
				const minutesStr = this.pluraliseTime(minutes, 'minute');
				const secondsStr = this.pluraliseTime(seconds, 'second');
				const timeStr = daysStr + hoursStr + minutesStr + secondsStr;
				
				return timeStr.replace(/,\s*$/, '');
			}
		},
		pluraliseTime(num, singular) {
			return num > 0 ? num + (num === 1 ? ' '+singular+', ' : ' '+singular+'s, ') : '';
		},
	},
	computed: {
		org() {
			return this.$store.state.gui.organisation;
		},
		attempts() {
			// group activity by user attempts
			return (!this.course) ? [] : this.$store.getters['courses/getCourseAttempts'](this.course.id);
		},
		filteredAttempts() {
			// attempt filter
			let f1 = (this.attemptFilter) ? this.attempts.filter(a => {
				let bool = false;
				if (this.attemptFilter.value === 'unattempted') {
					bool = (a.attempt === null);
				} else if (this.attemptFilter.value === 'finished') {
					bool = (a.completed !== false);
				} else if (this.attemptFilter.value === 'unfinished') {
					bool = (a.completed === false && a.attempt !== null);
				} else if (this.attemptFilter.value === 'passed') {
					bool = (a.tasks.result === true);
				} else if (this.attemptFilter.value === 'failed') {
					bool = (a.tasks.result === false);
				}
				
				return bool;
				
			}) : this.attempts.filter(a => a.attempt !== null);
			
			// serch term filter
			if (this.search) {				
				if (this.search.match(this.idRegex) !== null) {
					// id search
					const ids = this.search.split(',').map(id => { 
						return parseInt(id);
					});
					
					// find attempt matching supplied activity id
					return f1.filter(attempt => {
						const activity = attempt.activities.find(a => ids.includes(a.id));
						return (activity) ? ids.includes(activity.id) : false;
					});
					
				} else {
					// name search
					return f1.filter(a => a.user.fullName.toLowerCase().includes(this.search.toLowerCase()));
				}
				
			} else {
				return f1;
			}
			//return f1;
		},
		previewAttempt() {
			return this.filteredAttempts[this.previewIndex] || null;
		},
		filteredActivities() {
			if (!this.previewAttempt) {
				return [];
			}
			
			return (this.activityFilter) ? this.previewAttempt.activities.filter(a => {
				// filter activity log
				const value = this.activityFilter.value;
				
				if (value === 'correct') {
					return (a.activityType === 'task' && a.activityData.taskResult === true);
					
				} else if (value === 'incorrect') {
					return (a.activityType === 'task' && a.activityData.taskResult === false);
					
				} else if (value === 'pending') {
					return (a.activityType === 'task' && a.activityData.taskResult === null);
					
				} else {
					return (a.activityType === 'task');
				}
				
			}) : this.previewAttempt.activities;
		},
	},
};
</script>

<style lang="scss">
#activitylist {
	width: 100%;
	form.mark {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
		input {
			order: -1;
			width: 112px;
			height: 30px;
			padding: 0 15px;
			border: 1px solid var(--pri-bg);
			color: var(--pan-col);
			background:  var(--pan-bg);
			border-top-left-radius: 15px;
			border-bottom-left-radius: 15px;
			transition: .3s easein-out;
		}
		button {
			min-width: 112px;
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			&:hover {
				+input {
					border-color: var(--pri-bg-hvr);
				}
			}
		}
		span {
			width: 100%;
		}
	}
	.wrapper {
		display: flex;
		.c1 {
			min-width: 290px;
		}
		.c2 {
			max-width: 420px;
			&.sticky {
				top: 140px;
			}
		}
		table.summary {
			width: 150px;
			th {
				white-space: nowrap;
			}
		}
		.preview {
			table.numeric {
				svg {
					width: 24px;
					height: 24px;
				}
			}
		}
	}
	@media only screen and (min-width: 768px) {
		.wrapper {
			.c1 {
				flex-grow: 1;
				margin-right: 20px;
			}
			.c1,
			.c2 {
				width: calc(50% - 10px);
			}
		}
	}
}
</style>
